<template>
    <div :class="'avatar '+extraClass" v-html="identicon"></div>
</template>

<script>

import { toSvg } from 'jdenticon';

export default {
    name: 'UserIdenticon',
    props: ['id', 'size', 'extraClass'],
    computed: {
        icon_size () {
            return (this.size) ? this.size : 36;
        },
        identicon () {
            return toSvg(this.id, this.icon_size);
        }
    }
}
</script>
